import { render, staticRenderFns } from "./Admin.vue?vue&type=template&id=52b64580&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=ts"
export * from "./Admin.vue?vue&type=script&lang=ts"
import style0 from "./Admin.vue?vue&type=style&index=0&id=52b64580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b64580",
  null
  
)

export default component.exports